import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
// NOTE: this _was_ an external package, we took it in to IWP to fix bugs in it since it is no longer maintained.
import GravityFormForm from 'components/station-gatsby-gravityforms-component/src';

import './form.scss';

interface Props {
  id: number;
  headline: string;
}

const Form: React.FC<Props> = (props) => {
  const formData = useStaticQuery(
    graphql`
      query FormBlockFields {
        forms: allGfForm {
          edges {
            node {
              ...GravityFormComponent
            }
          }
        }
      }
    `
  );

  console.log(formData);

  const handleError = (e: any) => {
    console.log('error:', e);
    console.error('lambda endpoint:', process.env.LAMBDA_ENDPOINT);
  };

  return (
    <div className="form">
      <div className="form__wrapper">
        {props.headline && <h4 className="form__headline">{props.headline}</h4>}
        <div className="form__form">
          <div className="form__form-form">
            <GravityFormForm id={props.id} formData={formData.forms} lambda={process.env.LAMBDA_ENDPOINT} errorCallback={handleError} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;

export const query = graphql`
  fragment FormBlock on WpAcfFormBlock {
    AcfForm {
      id
      headline
    }
  }
`;
